import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { ColumnSelectComponent } from '../column-select/column-select.component';

@Component({
  selector: 'app-overall-report',
  templateUrl: './overall-report.component.html',
  styleUrls: ['./overall-report.component.css']
})
export class OverallReportComponent implements OnInit {

  private dp = [];
  displayedColumns = ['chx_select', 'sr', 'invoice_no', 'customer_name', 'mobile', 'permit', 'male_seat_count',
    'female_seat_count', 'total_seat', 'room_type', 'hotel_name', 'food', 'final_total', 'paid_amount',
    'remain_amount', 'reference', 'comment'];

  displayedColumns2 = ['sr', 'invoice_no', 'customer_name', 'mobile', 'permit', 'male_seat_count',
    'female_seat_count', 'total_seat', 'room_type', 'hotel_name', 'food', 'final_total', 'paid_amount',
    'remain_amount', 'reference', 'comment'];

  model = { 'trip_status': 'active', 'title': 'التقرير الشامل', 'trip_id': '0' };

  today = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

  search_prog = {
    'placeholder': 'اسم البرنامج/ رقم البرنامج', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`trip`', 'selected_no': 'trip_id',
      'field_list': ['trip_name', 'trip_number'],
      'condition': " AND `trip`.`arrival_date` >= '" + this.today + "'"
    }]
  };

  dialog_data = [{ 'id': 'sr', 'title_ar': 'الرقم', 'title_en': 'Number', 'checked': '1' },
  { 'id': 'invoice_no', 'title_ar': 'رقم العقد/ الفاتورة', 'title_en': 'Contract/ Invoice Number', 'checked': '1' },
  { 'id': 'customer_name', 'title_ar': 'اسم المسافر', 'title_en': 'Traveler Name', 'checked': '1' },
  { 'id': 'customer_name_en', 'title_ar': 'الاسم الإنجليزي', 'title_en': 'English Name', 'checked': '0' },
  { 'id': 'mobile', 'title_ar': 'رقم الجوال', 'title_en': 'Mobile', 'checked': '1' },
  { 'id': 'age', 'title_ar': 'العمر', 'title_en': 'Age', 'checked': '0' },
  { 'id': 'gender', 'title_ar': 'الجنس', 'title_en': 'Gender', 'checked': '0' },
  { 'id': 'trip_depart_date', 'title_ar': 'تاريخ المغادرة', 'title_en': 'Depart Date', 'checked': '0' },
  { 'id': 'trip_arrival_date', 'title_ar': 'تاريخ العودة', 'title_en': 'Return Date', 'checked': '0' },
  { 'id': 'depend_count', 'title_ar': 'عدد التابعين', 'title_en': 'Dependent Count', 'checked': '0' },
  { 'id': 'permit', 'title_ar': 'التصريح', 'title_en': 'Permit', 'checked': '1' },
  { 'id': 'male_seat_count', 'title_ar': 'عدد مقاعد الرجال', 'title_en': 'Male Seats', 'checked': '1' },
  { 'id': 'female_seat_count', 'title_ar': 'عدد مقاعد النساء', 'title_en': 'Female Seats', 'checked': '1' },
  { 'id': 'total_seat', 'title_ar': 'مجموع المقاعد', 'title_en': 'Total Seat', 'checked': '1' },
  { 'id': 'room_type', 'title_ar': 'نوع الغرفة', 'title_en': 'Room Type', 'checked': '1' },
  { 'id': 'hotel_name', 'title_ar': 'الفندق', 'title_en': 'Hotel', 'checked': '1' },
  { 'id': 'food', 'title_ar': 'الوجبات', 'title_en': 'Meals', 'checked': '1' },
  { 'id': 'final_total', 'title_ar': 'المبلغ', 'title_en': 'Amount', 'checked': '1' },
  { 'id': 'paid_amount', 'title_ar': 'المدفوع', 'title_en': 'Paid', 'checked': '1' },
  { 'id': 'remain_amount', 'title_ar': 'المتبقي', 'title_en': 'Remaining', 'checked': '1' },
  { 'id': 'tax', 'title_ar': 'الضريبة', 'title_en': 'Tax', 'checked': '0' },
  { 'id': 'reference', 'title_ar': 'المرجع', 'title_en': 'Reference', 'checked': '1' },
  { 'id': 'comment', 'title_ar': 'الملاحظات', 'title_en': 'Comments', 'checked': '1' }];
  

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  colDialogRef: MatDialogRef<ColumnSelectComponent>;

  trip_detail = '';
  trip_info;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private route: ActivatedRoute, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  Overall_Report; Prog_Name; Prog_No;
  Program_Placeholder; Trip_Msg; Departure_Date; Return_Date;
  No_Traveler_Msg;

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Overall_Report').subscribe((res: string) => {
      this.Overall_Report = res;
    });
    this.model['title'] = this.Overall_Report;

    translate.get('Prog_Name').subscribe((res: string) => {
      this.Prog_Name = res;
    });

    translate.get('Prog_No').subscribe((res: string) => {
      this.Prog_No = res;
    });

    translate.get('Program_Placeholder').subscribe((res: string) => {
      this.Program_Placeholder = res;
    });
    this.search_prog.placeholder = this.Program_Placeholder;

    translate.get('Trip_Msg').subscribe((res: string) => {
      this.Trip_Msg = res;
    });

    translate.get('Departure_Date').subscribe((res: string) => {
      this.Departure_Date = res;
    });

    translate.get('Return_Date').subscribe((res: string) => {
      this.Return_Date = res;
    });

    translate.get('No_Traveler_Msg').subscribe((res: string) => {
      this.No_Traveler_Msg = res;
    }); 
  }

  ngOnInit() {
  }

  change_status() {
    if (this.model['trip_status'] == 'active')
      this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` >= '" + this.today + "'";
    else
      this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` < '" + this.today + "'";
  }

  onChangeProg = function (search_result: object) {
    this.model['trip_id'] = (search_result['no'] != '' ? search_result['no'] : '0');

    let query = "SELECT `trip`.* FROM `trip` WHERE `trip`.`trip_id` = '" + this.model['trip_id'] + "' AND `trip`.`status` = '1'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.trip_info = data.data['list']['0'];

      });
  }

  search() {

    if (this.model['trip_id'] == '0') {
      alert(this.Trip_Msg);
      return;
    }

    let obj = { cmd: 'getOverallRep', 'trip_id': this.model['trip_id'] };

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;

      });
  }

  column_select() {
    this.colDialogRef = this.dialog.open(ColumnSelectComponent, {
      hasBackdrop: false,
      data: this.dialog_data
    });
    this.colDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          console.log(result);
          this.dialog_data = result;
          this.displayedColumns = ['chx_select'];
          this.displayedColumns2 = [];

          this.dialog_data.forEach(element => {
            if (element.checked == '1') {
              this.displayedColumns.push(element.id);
              this.displayedColumns2.push(element.id);
            }
          });
        }
      });

  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Overall_Report + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Prog_Name + ': ' + this.trip_info['trip_name'] + '</td><td width="33%"> ' +
      this.Prog_No + ': ' + this.trip_info['trip_number'] + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Departure_Date + ': ' + this.trip_info['departure_date'] + '</td><td width="33%"> ' +
      this.Return_Date + ': ' + this.trip_info['arrival_date'] + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('prog_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  printPassport() {
    let count = 0;
    let member_list = '';
    this.dp.forEach(element => {
      if ((document.getElementById('chx_select_' + element.member_id) as HTMLInputElement).checked) {
        count++;
        if (member_list != '')
          member_list += ';';
        member_list += element.member_id; 
      }
    });
    console.log(member_list);

    if (count == 0) 
      alert(this.No_Traveler_Msg);
    else {
      let form = (document.getElementById('form1') as HTMLFormElement);
      let html_data_field = document.forms[form.id]['html_data'] as HTMLInputElement;
      
      if (count == 1) 
        form.action = this.applicationConstants.generatePassport + "?member_id=" + member_list; 
      else if (count > 1) {
        html_data_field.value = String(member_list);
        form.action = this.applicationConstants.generatePassport + "?member_list"; 
      }
      form.submit();
    }
  }

  selectAll() {
    var selectAllInput = document.getElementById('chx_select_all') as HTMLInputElement;
    
    this.dp.forEach(element => {
      (document.getElementById('chx_select_' + element.member_id) as HTMLInputElement).checked = selectAllInput.checked;
    });
  }

}
